export const loadStripeScript = () => {
    const scriptElementId = 'stripe-v3-script';
    return new Promise((resolve, reject) => {
        const existingScriptElement = document.getElementById(scriptElementId);
        if (existingScriptElement && existingScriptElement.className === 'loaded') {
            resolve();
        }
        // remove element if previous load failed and retry
        if (existingScriptElement) {
            existingScriptElement.remove();
        }
        const scriptElement = document.createElement('script');
        scriptElement.id = scriptElementId;
        scriptElement.onload = () => {
            scriptElement.className = 'loaded';
            resolve();
        };
        scriptElement.onerror = () => reject(new Error('Failed to load Stripe SDK'));
        scriptElement.src = 'https://js.stripe.com/v3/';
        document.head.appendChild(scriptElement);
    });
};
